import { useEffect, useRef, useState } from 'react';

const PROGRESS_MAX_VALUE = 90;

export const useMockProgress = () => {
  const [mockProgress, setMockProgress] = useState(0);
  const intervalId = useRef<NodeJS.Timeout | null>();

  useEffect(() => {
    const incrementProgress = () => {
      if (!intervalId.current) return;
      setMockProgress((prev) => {
        const next = prev + (Math.random() * 10 + 150) / 100;
        if (next >= PROGRESS_MAX_VALUE) {
          clearInterval(intervalId.current!);
          return PROGRESS_MAX_VALUE;
        }
        return next;
      });
    };

    intervalId.current = setInterval(incrementProgress, Math.floor(Math.random() * 1300 + 500));
    return () => {
      if (intervalId.current) clearInterval(intervalId.current);
    };
  }, []);

  return { mockProgress, setMockProgress, intervalId };
};
